import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import QuestionReview from "../../components/QuestionReview";

export default function WrongQuestions() {
  const [qs, setQs] = useState([]);
  useEffect(() => { api.get("/student/wrong-questions").then((r) => setQs(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-2">Wrong Questions</h1>
      <p className="text-sm text-content-secondary mb-6">Every question you got wrong — revise and master them.</p>
      {qs.length === 0 ? <div className="card-surface p-8 text-center text-content-muted">No wrong questions. Keep it up!</div>
        : <div className="space-y-4">{qs.map((q) => <QuestionReview key={q.id} q={q} />)}</div>}
    </div>
  );
}
